<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import { useForm } from 'vee-validate';
import * as yup from 'yup';

import formAlerts from '@/components/form-alerts/form-alerts.vue';

const { status } = storeToRefs(useUserStore());
const { resetPassword } = useUserStore();
const { toggleModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const router = useRouter();
const route = useRoute();

const { closeModal } = useModalsStore();

const emit = defineEmits(['onSubmit']);
const props = defineProps<{
    page: boolean;
}>();

let formAlert = ref();
const activeValidation = ref(false);
const validate = computed(() => {
    return yup.object({
        password: yup.string().required(),
        confirmPassword: yup.string().required().oneOf([yup.ref('password')])
    });
});

const { errors, useFieldModel, handleSubmit } = useForm({
    validationSchema: validate
});
const [password, confirmPassword] = useFieldModel(['password', 'confirmPassword']);

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    emit('onSubmit', true);
    const error = await resetPassword(route.params.userId, values.password, route.params.token);
    emit('onSubmit', false);
    activeValidation.value = false;
    if (error) {
        resetForm();
        await formAlert.value.addMsg({type: 'error', content: 'modals.alerts.errorPasswordReset'});
    } else {
        resetForm();
        await formAlert.value.addMsg({type: 'success', content: 'modals.alerts.successPasswordReset'});
        
        router.push({ name: 'grid' });
        closeModal('resetpassword');
    }
});
</script>

<template src="./modal-resetpassword.html"></template>
